module.exports = __webpack_public_path__ + "static/media/add-icon.56fb0cdb.svg";